import { Component, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationService } from '../services/authentication.service';
interface LeadUser {
  _id: string;
  userName?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  contactNo?: number;
}

interface Lead {
  _id: string;
  userId: LeadUser;
  merchantId: string;
  prompt: string;
  shareConsent: boolean;
  status: string;
  createdAt: string;
  updatedAt?: string;
}

@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.scss']
})
export class LeadsComponent implements OnInit {

  loading = false;

  leads: Lead[] = [];

  merchantId: string = '';

  page = 1;
  limit = 10;
  totalItems = 0;

  spinnerType: any;

  constructor(
    private authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.getMerchantLeads();
  }

  getMerchantLeads(): void {

  const token = localStorage.getItem('merchant_token');

  if (!token) {
    console.error('Merchant token not found');
    return;
  }

  const helper = new JwtHelperService();
  const decoded: any = helper.decodeToken(token);

  this.merchantId = decoded.id;

  if (!this.merchantId) {
    console.error('Merchant ID not found in token');
    return;
  }

  this.loading = true;

  this.authService
    .getMerchantLeads(
      this.merchantId,
      this.page,
      this.limit
    )
    .subscribe(

      (res: any) => {

        this.loading = false;

        console.log('Merchant Leads Response:', res);

        if (res.success) {
          this.leads = res.leads || res.data || [];

          this.totalItems =
            res.total ||
            res.totalItems ||
            this.leads.length;
        } else {
          this.leads = [];
        }

      },

      (error: any) => {

        this.loading = false;

        console.error('Failed to fetch merchant leads:', error);

        if (error?.error?.message) {
          this.authService.successMessage(
            error.error.message,
            'error'
          );
        }

      }
    );
}

markAsContacted(lead: Lead): void {

  this.authService.markLeadContacted(lead._id).subscribe(
    (res: any) => {

      lead.status = 'contacted';

      this.authService.successMessage(
        'Lead marked as contacted',
        'success'
      );

    },
    (error: any) => {

      console.error(error);

      this.authService.successMessage(
        error?.error?.message || 'Failed to update lead',
        'error'
      );

    }
  );
}

archiveLead(lead: Lead): void {

  this.authService.archiveLead(lead._id).subscribe(
    (res: any) => {

      this.leads = this.leads.filter(
        item => item._id !== lead._id
      );

      this.authService.successMessage(
        'Lead archived successfully',
        'success'
      );

    },
    (error: any) => {

      console.error(error);

      this.authService.successMessage(
        error?.error?.message || 'Failed to archive lead',
        'error'
      );

    }
  );
}

deleteLead(lead: Lead): void {

  if (!confirm('Are you sure you want to delete this lead?')) {
    return;
  }

  this.authService.deleteLead(lead._id).subscribe(
    (res: any) => {

      this.leads = this.leads.filter(
        item => item._id !== lead._id
      );

      this.authService.successMessage(
        'Lead deleted successfully',
        'success'
      );

    },
    (error: any) => {

      console.error(error);

      this.authService.successMessage(
        error?.error?.message || 'Failed to delete lead',
        'error'
      );

    }
  );
}


  getStatusClass(status: string): string {

    switch (status?.toLowerCase()) {

      case 'new':
        return 'status-new';

      case 'contacted':
        return 'status-contacted';

      case 'closed':
        return 'status-closed';

      default:
        return 'status-new';

    }

  }


  onPageChange(pageNumber: number): void {

    this.page = pageNumber;

    this.getMerchantLeads();

  }

}